import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { TClientForm, Tdsm } from "../types/index.type";

// Define a type for the slice state
type ClientState = {
  clients: TClientForm[];
  sharedClients: TClientForm[];
  filteredOwnedClients: TClientForm[];
  filteredSharedClients: TClientForm[];
  clientForm: TClientForm;
  dsm: Tdsm[];
  customizationList: any[];
  note_type_instructions: {
    [key: number]: string | { note: string; is_system: boolean };
  };
  suggestion: string;
  isEditing: boolean;
};

// Initial state
const initialState: ClientState = {
  clients: [],
  sharedClients: [],
  filteredOwnedClients: [],
  filteredSharedClients: [],
  dsm: [],
  clientForm: {
    name: "",
    category_type: 0,
    gender_type: 0,
    language_type: 0,
    diagnosis_ids: [],
    refer_type: 0,
    mrn: "",
    date_of_birth: null,
    context: "",
  },
  customizationList: [],
  note_type_instructions: {},
  suggestion: "",
  isEditing: false,
};

// Slice
const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setClients: (state, action: PayloadAction<TClientForm[]>) => {
      state.clients = action.payload;
    },
    setSharedClients: (state, action: PayloadAction<TClientForm[]>) => {
      state.sharedClients = action.payload;
    },
    setFilteredOwnedClients: (state, action: PayloadAction<TClientForm[]>) => {
      state.filteredOwnedClients = action.payload;
    },
    setFilteredSharedClients: (state, action: PayloadAction<TClientForm[]>) => {
      state.filteredSharedClients = action.payload;
    },
    setClientForm: (state, action: PayloadAction<TClientForm>) => {
      state.clientForm = action.payload;
    },
    setDsm: (state, action: PayloadAction<{ id: number; code: string; name: string }[]>) => {
      state.dsm = action.payload;
    },
    setCustomizationList: (state, action: PayloadAction<any[]>) => {
      state.customizationList = action.payload;
    },
    setNoteTypeInstructionNote: (
      state,
      action: PayloadAction<{
        [key: number]: string | { note: string; is_system: boolean };
      }>,
    ) => {
      state.note_type_instructions = action.payload;
    },
    setIsEditing: (state, action: PayloadAction<boolean>) => {
      state.isEditing = action.payload;
    },
    resetClientForm: (state) => {
      state.clientForm = { ...initialState.clientForm };
    },
    setSuggestion: (state, action: PayloadAction<string>) => {
      state.suggestion = action.payload;
    },
    clearSuggestion: (state) => {
      state.suggestion = "";
    },
  },
});

// Actions
export const {
  setClientForm,
  setClients,
  setSharedClients,
  setFilteredOwnedClients,
  setFilteredSharedClients,
  resetClientForm,
  setDsm,
  setIsEditing,
  setNoteTypeInstructionNote,
  setCustomizationList,
  setSuggestion,
  clearSuggestion,
} = clientSlice.actions;

// Reducer
export default clientSlice.reducer;
